import {XDRPage} from './XDR.jsx';
export default XDRPage;
